import { render } from "./PartnerSezzle.vue?vue&type=template&id=fbbdd206"
import script from "./PartnerSezzle.vue?vue&type=script&lang=js"
export * from "./PartnerSezzle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__